import dayjs from 'dayjs'
import i18n from '~/i18n'

export function formatReturnDate(value: string | null, includeTime = true) {
    if (!value) return '—'
    const parsed = dayjs(value)
    if (!parsed.isValid()) return '—'
    return parsed.locale(i18n.language).format(includeTime ? 'D MMM YYYY, HH:mm' : 'D MMM YYYY')
}

export function formatReturnMoney(amount: string | null, currency: string) {
    if (amount === null || amount === '') return '—'
    try {
        return new Intl.NumberFormat(i18n.language, {
            style: 'currency',
            currency,
            currencyDisplay: 'narrowSymbol',
            maximumFractionDigits: 2,
        }).format(Number(amount))
    } catch {
        return `${amount} ${currency}`
    }
}
